import React, { useState } from 'react';
import caret from '../../images/caret-language-picker.svg';
import { post } from '../Services/http';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const ChannelPicker = ({ items }) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentCountryCode = 'Europe';

  if (!items || items.length < 1) {
    return;
  }

  const selectedOption = items.find((items) => items.isSelected === true);

  const onOptionClick = async (item) => {
    setIsOpen(false);

    const response = await post('/api/cart/changechannel', {
      channelSystemId: item.channelSystemId,
    });

    if (response.ok && response.redirected) {
      location.href = response.url;
    } else {
      console.error('Failed to change country');
    }
  };

  console.log(currentCountryCode);

  return (
    <>
      <div className="channel-picker__intro">
        {translate('channel-picker.intro')}
      </div>
      <div className={`channel-picker__options${isOpen ? ' open' : ''}`}>
        {!!items.length &&
          items.map((item) => (
            <button
              className={`btn btn--secondary channel-picker__option ${
                item.isSelected ? 'current' : ''
              }`}
              onClick={() => onOptionClick(item)}
              key={item?.channelSystemId}
            >
              <div
                className={`channel-picker__fake-radio ${
                  item.isSelected && 'active'
                }`}
              ></div>
              {item?.channelFlag ? (
                <img src={item?.channelFlag} className="channel-picker__flag" />
              ) : (
                <div className="channel-picker__flag-placeholder"></div>
              )}
              {item.channelListName}
            </button>
          ))}
      </div>
    </>
  );
};

export default ChannelPicker;
